/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type DeleteHardwareItemMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type DeleteHardwareItemMutation = {
  deleteHardwareItem: Pick<
    Types.HardwareItem,
    "id" | "sku_code" | "total_quantity" | "available_quantity"
  >;
};

export const DeleteHardwareItemDocument = gql`
  mutation DeleteHardwareItem($id: Float!) {
    deleteHardwareItem(id: $id) {
      id
      sku_code
      total_quantity
      available_quantity
    }
  }
`;

/**
 * __useDeleteHardwareItemMutation__
 *
 * To run a mutation, you first call `useDeleteHardwareItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHardwareItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHardwareItemMutation, { data, loading, error }] = useDeleteHardwareItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHardwareItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteHardwareItemMutation,
    DeleteHardwareItemMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteHardwareItemMutation,
    DeleteHardwareItemMutationVariables
  >(DeleteHardwareItemDocument, baseOptions);
}
export type DeleteHardwareItemMutationHookResult = ReturnType<
  typeof useDeleteHardwareItemMutation
>;
export type DeleteHardwareItemMutationResult =
  ApolloReactCommon.MutationResult<DeleteHardwareItemMutation>;
export type DeleteHardwareItemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteHardwareItemMutation,
    DeleteHardwareItemMutationVariables
  >;
